import { useState, useEffect } from "react";
import ButtonIcon from "../../components/ButtonIcon";
import NestedDataTable from "../components/NestedDataTable";
import CompanyScreen from "../components/CompanyScreen";
import OpticScreen from "../components/OpticScreen";
import { post } from "../utils/api";
import { userData } from "../../js/utils";

import "../css/EmpresasOpticas.css";

let datosEmpresa = [];

const tokenSesion = userData ? userData.token : "";

let datosColEmpresa = [
  { name: "Id", size: "size1" },
  { name: "NIF", size: "size2" },
  { name: "Nombre Empresa", size: "size4" },
  { name: "Dirección", size: "size4" },
  { name: "Teléfono", size: "size2" },
  { name: "Móvil", size: "size2" },
  { name: "Email", size: "size3" },
  { name: "", size: "" },
];

let datosColOptica = [
  { name: "Id", size: "size1" },
  { name: "Nombre Comercial", size: "size4" },
  { name: "Nombre Corto", size: "size4" },
  { name: "Teléfono", size: "size2" },
  { name: "Móvil", size: "size2" },
  { name: "Email", size: "size3" },
];

export default function EmpresasOpticas(props) {
  const [companyList, setCompanyList] = useState(datosEmpresa);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  const [isOpticOpen, setIsOpticOpen] = useState(false);
  const [idOptica, setIdOptica] = useState(-2);
  const [idEmpresa, setIdEmpresa] = useState(-1);

  // const [isLoading, setIsLoading] = useState(false);

  const openCompanyPopup = (id) => {
    setIdEmpresa(id);
    setIsCompanyOpen(true);
  };

  const closeCompanyPopup = () => {
    setIdEmpresa(-2);
    setIsCompanyOpen(false);
  };

  const newCompany = () => {
    setIdEmpresa(-1);
    setIsCompanyOpen(true);
  };

  const openOpticPopup = (id) => {
    setIdOptica(id);
    setIsOpticOpen(true);
  };

  const closeOpticPopup = () => {
    setIdOptica(-2);
    setIsOpticOpen(false);
  };

  const newOptic = (id) => {
    // console.log("ID EMPRESA RECIBIDO:", id);
    setIdEmpresa(id);
    setIdOptica(-1);
    setIsOpticOpen(true);
  };

  async function obtenerEmpresas() {
    // setIsLoading(true);
    datosEmpresa = [];
    let json_empresas = [];
    let jsonToken = { token: tokenSesion };

    json_empresas = await post("Configuracion/ListarEmpresas.php", jsonToken);

    if (Array.isArray(json_empresas)) {
      for (const el of json_empresas) {
        let empresa = {
          idEmpresa: el.idEmpresa,
          nombre_empresa: el.nombre_empresa,
          NIF: el.NIF,
          direccion: el.direccion,
          telefono_fijo: el.telefono_fijo,
          telefono_movil: el.telefono_movil,
          email: el.email,
          opticas: [],
        };

        let jsonOpticas = [];
        await obtenerOpticas(empresa.idEmpresa, jsonOpticas);

        empresa.opticas = jsonOpticas;

        datosEmpresa.push(empresa);
      }

      setCompanyList(datosEmpresa);
    }
    // setIsLoading(false);
  }

  useEffect(() => {
    obtenerEmpresas();
  }, []);

  async function obtenerOpticas(id, opticas) {
    let json_opticas = [];
    let jsonToken = { token: tokenSesion, idEmpresa: id };
    json_opticas = await post("Configuracion/ListarOpticas.php", jsonToken);

    if (Array.isArray(json_opticas)) {
      json_opticas.forEach((el) => {
        let opt = {
          idOptica: el.idOptica,
          nombre: el.nombre,
          nombre_corto: el.nombre_corto,
          NRS: el.NRS,
          telefono: el.telefono,
          movil: el.movil,
          email: el.email,
        };

        opticas.push(opt);
      });
    }
  }

  if (!props.show) {
    return <></>;
  }

  /*if (isLoading) {
    return <div className="spinner" />;
  }*/

  return (
    <div>
      {isCompanyOpen && (
        <CompanyScreen
          {...props}
          show={isCompanyOpen}
          closeFunction={() => {
            closeCompanyPopup();
          }}
          companyId={idEmpresa}
          onSave={(newId) => {
            if (newId) setIdEmpresa(newId);
            obtenerEmpresas();
          }}
        />
      )}
      <div className="settings-body-container">
        <div className="empresas-opticas">
          <span className="title-h2">Empresas y ópticas</span>
          <div className="empresas-opticas-options">
            <div className="general-header-separator" />
            <ButtonIcon
              text="Nueva Empresa"
              icon="/images/add-white.svg"
              onClick={() => {
                newCompany();
              }}
            />
          </div>
        </div>
        <NestedDataTable
          id="empresas-opticas-table"
          data={companyList}
          mainColumns={datosColEmpresa}
          nestedColumns={datosColOptica}
          openCompanyFunction={(id) => {
            openCompanyPopup(id);
          }}
          openOpticFunction={(id) => {
            openOpticPopup(id);
          }}
          newOpticFunction={(id) => {
            newOptic(id);
          }}
        />
      </div>
      {isOpticOpen && (
        <OpticScreen
          {...props}
          show={isOpticOpen}
          closeFunction={() => {
            closeOpticPopup();
          }}
          opticId={idOptica}
          companyId={idEmpresa}
          onSave={(newId) => {
            if (newId) setIdOptica(newId);
            obtenerEmpresas();
          }}
        />
      )}
    </div>
  );
}
